/**
 * 5-letter words for RSTLNE game
 * Exact words from original project
 */

const words5: string[] = [
  "STORM", "BLAZE", "PIANO", "JOKER", "EARTH", "FLINT", "CABIN", "SUGAR", "WHISK", "SIREN",
  "VALOR", "CHART", "HONEY", "TIGER", "ANGLE", "CLEAR", "BRAVE", "ZEBRA", "FRESH", "SPARK",
  "GRAPE", "GRIND", "DODGE", "HAPPY", "GLIDE", "FIELD", "RAZOR", "FLARE", "QUIET", "VIVID",
  "SHINE", "QUILT", "KNACK", "NOBLE", "TOWER", "TRUCE", "NINJA", "WORTH", "CLASP", "TABLE",
  "PRISM", "LATCH", "GLASS", "DREAM", "MAGIC", "RAVEN", "SHRUB", "IDEAL", "BEACH", "SWIFT",
  "GLEAM", "JUMPY", "FROST", "PENNY", "LUNAR", "EAGER", "QUARK", "PETAL", "TANGO", "DAISY",
  "LEMON", "AMBER", "YIELD", "SWOOP", "JEWEL", "WALTZ", "FABLE", "FLAME", "PLUMB", "IVORY",
  "MANGO", "SHARP", "VAPOR", "ARBOR", "KOALA", "BISON", "DANCE", "SPOON", "RIVER", "BRUSH",
  "KNIFE", "ORBIT", "OLIVE", "OCEAN", "STONE", "STAGE", "HOUSE", "SMILE", "ROBIN", "HATCH",
  "GAMER", "DELTA", "WOVEN", "CIDER", "GLEAN", "DRIFT", "ULTRA", "INSET", "WITTY", "TULIP",
  "EXACT", "PLANT", "QUEEN", "SPICE", "EAGLE", "JOLLY", "VISTA", "BAKER", "BLISS", "CANDY",
  "VOCAL", "PRONG", "UNION", "GRASP", "ACORN", "PLAZA", "WHEEL", "KARMA", "URBAN", "THRUM",
  "GLINT", "VIGOR", "ANGEL", "YOUTH", "RIDER", "FLICK", "CRANE", "CLOVE", "ZESTY", "INBOX",
  "CRISP", "PIVOT", "BLEND", "BRISK", "SHARD", "FLAIR", "CHESS", "XENON", "BREAD", "CHIEF",
  "CLOCK", "COUCH", "DOUBT", "ELBOW", "FRAME", "GHOST", "GRANT", "GROUT", "HINGE", "JOINT",
  "LAUGH", "MATCH", "MOUSE", "NOISE", "PHASE", "POUND", "QUIRK", "ROUTE", "SHACK", "THICK",
  "TORCH", "UNCLE", "VOICE", "WATER", "YACHT", "BADGE", "CLIMB", "DENSE", "FAITH", "GLOBE",
  "HASTE", "JUDGE", "LEARN", "MIXED", "NICHE", "POSED", "QUICK", "ROUGH", "SLANT", "TOUGH",
  "VAULT", "WOUND", "BASIC", "CHANT", "DEPTH", "FIBER", "GLAND", "LOGIC", "MONEY", "NERVE",
  "PRUNE", "QUEST", "ROYAL", "TREND", "UNITE", "VOGUE", "WHALE", "ACTOR",
  "BENCH", "CRIME", "DAIRY", "ELITE", "FORUM", "GUEST", "HUMOR", "INNER", "JOUST", "KNEEL",
  "LINER", "MEDAL", "NOVEL", "OPERA", "PLATE", "QUOTA", "REBEL", "SCALE", "THEME", "WORLD"
];

export default words5;
